/**
 * Feedback Service
 * API service for user feedback operations
 */
import api from './api';

const feedbackService = {
  /**
   * Submit user feedback
   * @param {Object} feedbackData - The feedback data to submit
   * @returns {Promise} API response
   */
  submitFeedback: async (feedbackData) => {
    const response = await api.post('/feedback', feedbackData);
    return response.data;
  },

  /**
   * Check if user has already submitted feedback
   * @returns {Promise} Object with has_submitted and submitted_at
   */
  checkFeedbackStatus: async () => {
    const response = await api.get('/feedback/check');
    return response.data;
  },

  /**
   * Get current user's feedback
   * @returns {Promise} User's feedback data
   */
  getUserFeedback: async () => {
    const response = await api.get('/feedback');
    return response.data;
  },

  /**
   * Get all feedback (admin only)
   * @returns {Promise} All feedback with statistics
   */
  getAllFeedback: async () => {
    const response = await api.get('/feedback/all');
    return response.data;
  },

  /**
   * Export all feedback to Excel (admin only)
   * Downloads an Excel file with all feedback data sorted by submission date (oldest first)
   * @returns {Promise} Triggers file download
   */
  exportFeedbackToExcel: async () => {
    const response = await api.get('/feedback/export', {
      responseType: 'blob'
    });

    // Get filename from Content-Disposition header or use default
    const contentDisposition = response.headers['content-disposition'];
    let filename = 'feedback_export.xlsx';
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="(.+)"/);
      if (filenameMatch) {
        filename = filenameMatch[1];
      }
    }

    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return { success: true, filename };
  },
};

export default feedbackService;
